module.exports = __webpack_public_path__ + "img/cii-widget-tableview.4be1326a.png";